import { ProposalStatusEnum } from '@/types'
import type { BadgeVariants, ButtonVariants } from '@/ui'

export const PROPOSAL_DEFAULT_STATUSES: ProposalStatusEnum[] = [
  ProposalStatusEnum.DRAFT,
  ProposalStatusEnum.SENT,
  ProposalStatusEnum.ACCEPTED,
  ProposalStatusEnum.DECLINED,
  ProposalStatusEnum.EXPIRED,
]

export const PROPOSAL_STATUS_TRANSITIONS: Record<
  ProposalStatusEnum,
  {
    path: string
    options?: ProposalStatusEnum[]
    label?: string
    variant?: ButtonVariants['variant']
  }
> = {
  [ProposalStatusEnum.DRAFT]: {
    path: '',
    options: [ProposalStatusEnum.SENT],
  },
  [ProposalStatusEnum.SENT]: {
    path: 'send',
    variant: 'amber',
    label: 'Send Proposal',
    options: [ProposalStatusEnum.ACCEPTED, ProposalStatusEnum.DECLINED],
  },
  [ProposalStatusEnum.ACCEPTED]: {
    path: 'accept',
    variant: 'accent',
    label: 'Accept Proposal',
  },
  [ProposalStatusEnum.DECLINED]: {
    path: 'decline',
    variant: 'red',
    label: 'Decline Proposal',
  },
  [ProposalStatusEnum.EXPIRED]: {
    path: '',
    variant: 'amber',
  },
}

export const PROPOSAL_STATUS_COLORS: Record<ProposalStatusEnum, BadgeVariants['variant']> = {
  [ProposalStatusEnum.DRAFT]: 'secondary',
  [ProposalStatusEnum.SENT]: 'blue',
  [ProposalStatusEnum.ACCEPTED]: 'green',
  [ProposalStatusEnum.DECLINED]: 'destructive',
  [ProposalStatusEnum.EXPIRED]: 'yellow',
}

export const MOCK_PROPOSAL = {
  id: '01JVKYKCCA2G675F87VDNZ6Z14',
  number: 'PROP-0000002',
  status: ProposalStatusEnum.SENT,
  sections: [
    {
      type: 'Standard',
      display_name: 'Website Redesign Proposal',
    },
    {
      type: 'Services',
      display_name: 'Services',
    },
    {
      type: 'Terms',
      display_name: 'Terms and Conditions',
    },
  ],
}
